module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGBAMAAACDAP+3AAAAHlBMVEXMzMyWlpaqqqqcnJy+vr6jo6O3t7exsbG5ubnFxcVMOS22AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAb0lEQVRIiWNgGAWjYBSMgiEBmIwlQieAGMqGnhAGNhDqogCmWVmhDEzA5jzTgKHMiYEhhRnIwA5YGRkEGKZGMjAEgBjYgTtIO5MCA0sBbnNKQM4AmsPugNs9AZxA76g4MbAycOL21ygYBaNgFBABAAN0D8LhvUvDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.png
// module id = Gvv4
// module chunks = 1